/**
 * @generated SignedSource<<84540515474b1b2df81c22ff4782bedf>>
 * @relayHash 742933cd70a13ba75a577b9478ed4cb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 68c4fedc78c775b7990b4659d628aa24bff8ffd348df2033e5ee2830746b1a70

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { InlineCreateAdditionalFieldsEntrypointQuery } from './InlineCreateAdditionalFieldsEntrypointQuery.graphql';

const node: PreloadableConcreteRequest<InlineCreateAdditionalFieldsEntrypointQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "68c4fedc78c775b7990b4659d628aa24bff8ffd348df2033e5ee2830746b1a70",
    "metadata": {},
    "name": "InlineCreateAdditionalFieldsEntrypointQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
